import React, { createContext, useState, useRef } from 'react';
import { oneOfType, arrayOf, node, bool } from 'prop-types';
import { modifyAndReturnObservedEntries, getCurrentlyPlayingFrame } from '../helpers/videoPlayerHelpers';

export const VideoPlayerContext = createContext();

export const VideoPlayerProvider = ({
  children,
  autoPlayInViewport
}) => {
  const wrapperRef = useRef();
  const [playObserver, setPlayObserver] = useState(null);
  const [pauseObserver, setPauseObserver] = useState(null);

  if (autoPlayInViewport && !pauseObserver && !playObserver && typeof window !== 'undefined') {
    let currentlyPlayingFrame = null;
    let observedEntries = [];
    const defaultObserverOptions = {
      root: wrapperRef.current,
      rootMargin: '0px'
    };

    const observerCallback = ({ entries, isPlayObserver }) => {
      /* eslint-disable-next-line max-len */
      observedEntries = modifyAndReturnObservedEntries({ entries, isPlayObserver, observedEntries });
      /* eslint-disable-next-line max-len */
      currentlyPlayingFrame = getCurrentlyPlayingFrame({ checkForNoVideos: !isPlayObserver, observedEntries, currentlyPlayingFrame });
    };

    setPlayObserver(new IntersectionObserver(
      (entries) => observerCallback({ entries, isPlayObserver: true }),
      { ...defaultObserverOptions, threshold: 0.9 })
    );
    setPauseObserver(new IntersectionObserver(
      (entries) => observerCallback({ entries, isPlayObserver: false }),
      { ...defaultObserverOptions, threshold: 0.1 }
    ));
  }

  return (
    <VideoPlayerContext.Provider value={{ playObserver, pauseObserver, autoPlayInViewport }}>
      <div ref={wrapperRef} className="video-player-wrapper">
        {children}
      </div>
    </VideoPlayerContext.Provider>
  );
};

VideoPlayerProvider.propTypes = {
  children: oneOfType([
    node,
    arrayOf(node)
  ]).isRequired,
  autoPlayInViewport: bool
};

VideoPlayerProvider.defaultProps = {
  autoPlayInViewport: false
};